import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const GetCampaignSeedingApplicantsCountRequestSchema = z
  .object({
    campaignId: z.union([z.number(), z.string()]),
    nickname: z.string().optional(),
    gender: z.enum(['M', 'F']).optional(),
    ageRange: z.string().optional(),
    customerGender: z.enum(['M', 'F']).optional(),
    customerAgeRange: z.string().optional(),
    categoryCode: z.string().optional(),
    snsType: z.enum(['INSTAGRAM', 'YOUTUBE', 'TIKTOK', 'TWITTER', 'ETC']).optional(),
    likedBrand: z.boolean().optional(),
    likedByBrand: z.boolean().optional(),
    brandSoldHistory: z.boolean().optional(),
  })
  .describe('GetCampaignSeedingApplicantsCountRequestSchema');

export type GetCampaignSeedingApplicantsCountRequest = z.infer<
  typeof GetCampaignSeedingApplicantsCountRequestSchema
>;

const GetCampaignSeedingApplicantsCountResponseDataSchema = z
  .object({
    totalCount: z.number(),
  })
  .describe('GetCampaignSeedingApplicantsCountResponseDataSchema');

const GetCampaignSeedingApplicantsCountResponseSchema = createApiResponseSchema(
  GetCampaignSeedingApplicantsCountResponseDataSchema,
);

export type GetCampaignSeedingApplicantsCountResponse = z.infer<
  typeof GetCampaignSeedingApplicantsCountResponseSchema
>;

export const getCampaignSeedingApplicantsCount = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCampaignSeedingApplicantsCountRequestSchema),
    async ({ campaignId, ...query }: GetCampaignSeedingApplicantsCountRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetCampaignSeedingApplicantsCountResponse>(
          partnerApiPath.getCampaignSeedingApplicantsCount(campaignId),
          query,
        ),
      ),
    validateApiResponse(GetCampaignSeedingApplicantsCountResponseSchema),
  ),
);
